import { AO, AR, BR, CG, DK, GB, IQ, NG } from 'country-flag-icons/react/3x2';
import { CountryData } from 'types/wellGuardian';

const baseStyle = {
  display: 'inline-block',
  height: '1.5em',
  width: '2em',
  marginRight: '8px',
} as const;

const baseStyleUK = {
  display: 'inline-block',
  height: '1.5em',
  width: '2em',
  marginRight: '8px',
  marginTop: '4px',
} as const;

const CONGO_VIEW_BOX_PRODUCTION = '0 85.333 840 510';

const CountryFlagIcon = (country: string) => {
  if (country === CountryData.unitedKingdom) {
    return (
      <div data-testid="uk_flag_tag">
        <GB style={baseStyleUK} />
      </div>
    );
  }
  if (country === CountryData.denmark) {
    return <DK style={baseStyle} />;
  }
  if (country === CountryData.nigeria) {
    return <NG style={baseStyle} />;
  }
  if (country === CountryData.angola) {
    return <AO style={baseStyle} />;
  }
  if (country === CountryData.congo) {
    return (
      <CG
        style={{
          ...baseStyle,
          color: 'initial',
          fill: 'initial',
          stroke: 'initial',
        }}
        viewBox={CONGO_VIEW_BOX_PRODUCTION}
        preserveAspectRatio="xMidYMid meet"
      />
    );
  }
  if (country === CountryData.brazil) {
    return <BR style={baseStyle} />;
  }
  if (country === CountryData.iraq) {
    return <IQ style={baseStyle} />;
  }
  if (country === CountryData.argentina) {
    return <AR style={baseStyle} />;
  }
};

export default CountryFlagIcon;
